export default {
  'expired_code': 'Your password reset link has expired, click below to send a new password reset link.',
  'forgot_instructions': 'Please enter the email address you signed up with. If we have your account on file, you will receive an email containing a link to reset your password',
  'reset_sent': 'Password reset sent, please check your email and follow the instructions.',
  'reset_your_password': 'Reset your password',
  'return_to_sign_in': 'Return to Sign In',
  'send_password_reset': 'Send Password Reset Link',
  'unknown_error': 'There was an error sending the password reset, please try again.',
}
